import { LiveListEntity } from '@/types/live-lists'
import { OpenInNew } from '@mui/icons-material'
import { Box, Stack, Typography, IconButton, Tooltip } from '@mui/material'

type QBOVendorDetailsProps = {
  entityJson: LiveListEntity
}

export default function QBOVendorDetails({
  entityJson,
}: QBOVendorDetailsProps) {
  const vendor = entityJson.entity
  return (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Box>
            <Typography variant="caption" color="text.secondary">
              Billing Address
            </Typography>
            {vendor.bill_addr?.city ? (
              <>
                <Typography variant="body2">
                  {vendor.bill_addr?.line_1}
                </Typography>
                <Typography variant="body2">
                  {vendor.bill_addr?.line_2}
                </Typography>
                <Typography variant="body2">
                  {vendor.bill_addr?.city}, {vendor.bill_addr?.state}{' '}
                  {vendor.bill_addr?.postal_code}
                </Typography>
              </>
            ) : (
              <Typography variant="body2">None</Typography>
            )}
          </Box>
        </Stack>
        <Box>
          <Tooltip title="Open Vendor in QuickBooks Online">
            <IconButton
              sx={{ flexShrink: 0 }}
              component={'a'}
              href={`https://sandbox.qbo.intuit.com/app/vendordetail?nameId=${entityJson.entity_id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <OpenInNew />
            </IconButton>
          </Tooltip>
        </Box>
      </Stack>
    </Box>
  )
}
